import React from "react";
import QuotationsQueue from "../../../pharmacy/pages/quotations";
import { buildSalesQuotationColumns } from "./columns";

/**
 * /v2/sales/quotations.
 */

// Removed per the Sales prototype's Quotations view. "Inventory No" in particular is not
// lost: it is the same value the Evital No column relabels and links (./columns.jsx).
const OMITTED_LEGACY_COLUMNS = ["Duration", "Left", "Inventory No"];

function SalesQuotationsPage() {
    return (
        <QuotationsQueue
            title="Quotations"
            extraColumns={buildSalesQuotationColumns}
            omitHeaders={OMITTED_LEGACY_COLUMNS}
            quotationType="SALES_QUOTATIONS"
            includeFinance
        />
    );
}

export default SalesQuotationsPage;
